import type { PathType } from './types';
import { getPath } from './types';

export const administrationPaths: { [key: string]: PathType } = {
  approvalProcess: getPath('/system-admin/approval-process', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess'
  ]),
  approvalProcessAdd: getPath('/system-admin/approval-process/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess',
    'action.add'
  ]),
  approvalProcessEdit: getPath('/system-admin/approval-process/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess',
    'action.edit'
  ]),
  approvalProcessDetail: getPath('/system-admin/approval-process/detail', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess',
    'page.detail'
  ]),
  proposalApprovalProcess: getPath('/system-admin/proposal-approval-process', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.proposalApprovalProcess'
  ]),
  proposalApprovalProcessAdd: getPath('/system-admin/proposal-approval-process/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.proposalApprovalProcess',
    'action.add'
  ]),
  proposalApprovalProcessEdit: getPath('/system-admin/proposal-approval-process/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.proposalApprovalProcess',
    'action.edit'
  ]),
  proposalApprovalProcessDetail: getPath('/system-admin/proposal-approval-process/detail', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.proposalApprovalProcess',
    'page.detail'
  ]),
  handleProcess: getPath('/system-admin/handle-process', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.handleProcess'
  ]),
  handleProcessAdd: getPath('/system-admin/handle-process/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.handleProcess',
    'action.add'
  ]),
  handleProcessEdit: getPath('/system-admin/handle-process/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.handleProcess',
    'action.edit'
  ]),
  template: getPath('/system-admin/template', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.template'
  ]),
  templateAdd: getPath('/system-admin/template/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.template',
    'action.add'
  ]),
  templateEdit: getPath('/system-admin/template/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.template',
    'action.edit'
  ])
};
